import { render, staticRenderFns } from "./g-t-view.vue?vue&type=template&id=e03ee82e&scoped=true&"
import script from "./g-t-view.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-t-view.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03ee82e",
  null
  
)

export default component.exports